import PropTypes from 'prop-types';
import ProfitShareRevenue from './components/profit-share/ProfitShareRevenue';
import DaysInQuarter from './components/profit-share/DaysInQuarter';
import SummaryWithoutUtil from './components/profit-share/SummaryWithoutUtil';
import TotalCosts from './components/profit-share/TotalCosts';
import NetProfitAndLoss from './components/profit-share/NetProfitAndLoss';
import ProfitShareTotal from './components/profit-share/ProfitShareTotal';
import ProfitShareFees from './components/profit-share/ProfitShareFees';

const PsNoUtilThreshold = ({statement}) => {
  return (
    <div>
      <DaysInQuarter liveDaysInQ={statement.data.liveDaysInQ} />
      <SummaryWithoutUtil data={statement.data}/>
      <ProfitShareRevenue data={statement.data}/>
      <ProfitShareFees data={statement.data}/>
      <TotalCosts totalCosts={statement.data.totalCosts}/>
      <NetProfitAndLoss netProfitLossForPeriod={statement.data.netProfitLossForPeriod}/>
      <ProfitShareTotal totalToClient={statement.data.totalToClient} genericProfitShare={statement.data.genericProfitShare} />
    </div>
  )
}

export default PsNoUtilThreshold;

PsNoUtilThreshold.propTypes = {
  statement: PropTypes.object.isRequired,
};